/**
 * Location information.
 */
export interface Location {
    /**
     * The display name of the location.
     */
    displayName: string;

    /**
     * The fully qualified ID of the location.
     * For example, /subscriptions/00000000-0000-0000-0000-000000000000/locations/westus.
     */
    id: string;

    /**
     * The latitude of the location.
     */
    latitude: string;

    /**
     * The longitude of the location.
     */
    longitude: string;

    /**
     * The location name.
     */
    name: string;

    /**
     * The subscription Id.
     */
    subscriptionId: string;
}

/**
 * Location list operation response.
 */
export interface LocationListResult {
    /**
     * The list of locations.
     */
    value: Location[];
}

/**
 * Custom response to get all available geo-locations.
 */
export interface LocationsOperationResult {
    /**
     * The http status code.
     */
    httpStatusCode: number;

    /**
     * The subscription list.
     */
    value?: LocationListResult;
}
